export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	litten: {
		inherit: true,
		unreleasedHidden: true,
	},
	torracat: {
		inherit: true,
		unreleasedHidden: true,
	},
	incineroar: {
		inherit: true,
		unreleasedHidden: true,
	},
	rowlet: {
		inherit: true,
		unreleasedHidden: true,
	},
	dartrix: {
		inherit: true,
		unreleasedHidden: true,
	},
	decidueye: {
		inherit: true,
		unreleasedHidden: true,
	},
	popplio: {
		inherit: true,
		unreleasedHidden: true,
	},
	brionne: {
		inherit: true,
		unreleasedHidden: true,
	},
	primarina: {
		inherit: true,
		unreleasedHidden: true,
	},
	passimian: {
		inherit: true,
		unreleasedHidden: true,
	},
	oranguru: {
		inherit: true,
		unreleasedHidden: true,
	},
};
